﻿$.fn.dxCtrlIframeResize = function custom_dxCtrlIframeResize(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrliframeresize dx-ctrl");
        this.createInstance(new cdxCtrlIframeResize(this, option));
    }
    return this;
}

window.cdxCtrlIframeResize = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    this.$iFrame = null

    function mConstruit() {
        firstInit = true
        container.empty();
        container.css("posistion", "relative")

        var jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        jauge.mShow()

        if (option.disabled) {
            var $DivDisabled = $("<div style='width:100%;height:100%;background-color:transparent;position:absolute;z-index:1;'/>").appendTo(container)
            if (typeof option.onClick != 'undefined') {
                $DivDisabled.addClass("state-hover-rgba")
                $DivDisabled.on("click", function (e) {
                    e.stopPropagation()
                    option.onClick()
                });
            }
        }

        Me.$iFrame = $("<iframe style='width:100%;border:none;background-color:white;position:absolute;left:0;' scrolling='no'/></iframe>").appendTo(container)
        //if (option.disableLink) $iFrame.attr("sandbox","true")

        var firstLoad = true
        Me.$iFrame.on("load", function () {
            function mReSizeLoad() {
                if (typeof Me.$iFrame.contents == 'undefined') {
                    window.setTimeout(function () { mReSizeLoad() }, 200)
                } else {
                    Me.$iFrame.contents().find("body").css("height", "")
                    mResizeIframe()
                    jauge.mHide()
                }
            }
            mReSizeLoad()

            if (firstLoad) {
                firstLoad = false
                if (typeof option.onClick != 'undefined') {
                    //$(this).contents().addClass("state-hover")
                    $(this).contents().on("click", function (e) {
                        e.stopPropagation()
                        option.onClick()
                    });
                }
            }

            if (option.zoom) {
                var doc = Me.$iFrame[0].contentDocument || Me.$iFrame[0].contentWindow.document;
                doc.body.style.zoom = option.zoom + "%";
            }

            if (typeof option.onContentReady != 'undefined') option.onContentReady(Me)

        })

        if (typeof option.srcdoc != 'undefined') {
            Me.$iFrame.attr("srcdoc", option.srcdoc.remplacerTout("'", "&#039;").remplacerTout("\"", "&#34;")).appendTo(container)
        } else {
            Me.$iFrame.attr("src", option.src).appendTo(container)
        }

        //if (typeof option.onContentReady != 'undefined') option.onContentReady(Me)

        resizeObserver.mAdd(container, function () {
            mResizeIframe()
            timeoutResize = window.setTimeout(function () { mResizeIframe() }, 500)
        })

    }

    var changeInResize = false;
    function mResizeIframe() {
        if (container.closest("body").length == 0) return
        if (changeInResize) {
            changeInResize = false;
            return
        }
        if (typeof Me.$iFrame.contents == 'undefined') {
            window.setTimeout(function () { mResizeIframe() }, 200)
        } else {
            var height = Me.$iFrame.contents().find("body").innerHeight()
            if (height == 0) height = Me.$iFrame.contents().find("html").innerHeight()
            if (Me.$iFrame.contents().find("body").find(".divbodymessage").length > 0) { height += 30 }
            else { height += 10 }
            changeInResize = true
            Me.$iFrame.css("height", (height + ((typeof option.deltaX == 'undefined') ? 20 : option.deltaX)) + 'px')
            //window.setTimeout(function () { changeInResize = false }, 500)


            Me.$iFrame.contents().off("click")
            Me.$iFrame.contents().off("mousedown")
            Me.$iFrame.contents().off("mouseup")
            Me.$iFrame.contents().off("scroll")
            Me.$iFrame.contents().off("whell")
            Me.$iFrame.contents().off("mousewheel")
            Me.$iFrame.contents().on("click", function (e) { $('body').trigger('click', e); });
            Me.$iFrame.contents().on("mousedown", function (e) { $('body').trigger('mousedown', e); });
            Me.$iFrame.contents().on("mouseup", function (e) { $('body').trigger('mouseup', e); })
            Me.$iFrame.contents().on("scroll", function (e) { $('body').trigger('scroll', e); });
            Me.$iFrame.contents().on("whell", function (e) { $('body').trigger('whell', e); });
            Me.$iFrame.contents().on("mousewheel", function (e) {
                if (container.closest(".dx-scrollview").length > 0) {
                    var dxScroll = $(container.closest(".dx-scrollview")[0]).dxScrollView("instance")
                    var scrollTop = dxScroll.scrollTop() + e.originalEvent.deltaY
                    dxScroll.scrollTo(scrollTop)
                } else {
                    //on a pas de scrollview
                    $('body').trigger('mousewheel', e);
                }
            });
            console.log("on")

        }
    }

    this.mUpdate = function (src) {
        option.src = src
        Me.$iFrame.contents().off("click")
        Me.$iFrame.contents().off("mousedown")
        Me.$iFrame.contents().off("mouseup")
        Me.$iFrame.contents().off("scroll")
        Me.$iFrame.contents().off("whell")
        Me.$iFrame.contents().off("mousewheel")
        console.log("off")
        mConstruit()
    }

    this.destroy = function () {
        Me.$iFrame.contents().off("click")
        Me.$iFrame.contents().off("mousedown")
        Me.$iFrame.contents().off("mouseup")
        Me.$iFrame.contents().off("scroll")
        Me.$iFrame.contents().off("whell")
        Me.$iFrame.contents().off("mousewheel")
        console.log("off")
    }

    this.element = function () { return container; }
    this.component = function () { return dx; }

    mConstruit();

}